import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import LuceCircularProgress, {
  CircularProgressProps as Props
} from '../atom/CircularProgress'
import Box from '../base/Box'

export type LoaderProps = {
  children: React.ReactNode
} & Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.main
    }
  })
)

const Loader: React.FC<LoaderProps> = (props) => {
  const classes = useStyles()
  const { children, size, thickness, ...rest } = props
  return (
    <Box textAlign="center">
      <LuceCircularProgress
        className={classes.root}
        size={size ? size : 30}
        thickness={thickness ? thickness : 5.5}
        {...rest}
      />
      <br />
      {children}
    </Box>
  )
}

export default Loader
